var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.58203L15.7336 12.9363C15.6016 15.0707 15.5356 16.138 15.0006 16.9052C14.7361 17.2846 14.3955 17.6048 14.0006 17.8454C13.2018 18.332 12.1325 18.332 9.99395 18.332C7.8526 18.332 6.78192 18.332 5.98254 17.8445C5.58733 17.6034 5.24666 17.2827 4.98224 16.9027C4.4474 16.1342 4.38288 15.0655 4.25384 12.928L3.75 4.58203",
    stroke: "#DF0C3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.58268H17.5M13.3798 4.58268L12.8109 3.40912C12.433 2.62956 12.244 2.23978 11.9181 1.99669C11.8458 1.94277 11.7692 1.8948 11.6892 1.85327C11.3283 1.66602 10.8951 1.66602 10.0288 1.66602C9.14069 1.66602 8.69665 1.66602 8.32974 1.86112C8.24842 1.90436 8.17082 1.95426 8.09774 2.01032C7.76803 2.26327 7.58386 2.66731 7.2155 3.4754L6.71077 4.58268",
    stroke: "#DF0C3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91675 13.75L7.91675 8.75",
    stroke: "#DF0C3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 13.75L12.0833 8.75",
    stroke: "#DF0C3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.3abb4ca9522e7fd5e0f46921eb2114b9.svg";
export { ForwardRef as ReactComponent };